import React, { FormEvent, useState } from "react";
import { useHistory } from "react-router-dom";
import { api } from "services/api";
import { notify } from "services/notification";

import wallpaper from "assets/images/agendamento-fob-wallpaper.png";
import kemiraLogo from "assets/images/logo-kemira-black-header.png";
import webcolLogo from "assets/images/logo-webcol-preta.png";

import * as S from "./styles";

export const AgendamentoFob: React.FC = () => {
	const history = useHistory();
	const [orderNumber, setOrderNumber] = useState("");
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const value = orderNumber.trim();

		if (!value) {
			const errorMessage =
				"Digite o número da sales order para continuar.";
			setMessage(errorMessage);
			notify("error", errorMessage);
			return;
		}

		setLoading(true);
		setMessage(`Buscando a sales order ${value}...`);

		try {
			const { data } = await api.get(
				`/agendamento-fob/orders-fob/po-number/${encodeURIComponent(value)}`,
			);
			console.log("Retorno da API:", data);
			const successMessage = "Sales order encontrada com sucesso.";
			setMessage(successMessage);
			notify("success", successMessage);
			history.push({
				pathname: "/agendamento-fob/schedule",
				state: { order: data },
			});
		} catch (error: any) {
			console.error("Erro ao buscar sales order:", error);
			const apiMessage =
				error?.response?.data?.error?.message ||
				error?.response?.data?.message;

			const errorMessage =
				apiMessage || "Não foi possível buscar a sales order.";
			setMessage(errorMessage);
			notify("error", errorMessage);
		} finally {
			setLoading(false);
		}
	};

	return (
		<S.Page>
			<S.Frame>
				<S.Header>
					<S.KemiraLogo src={kemiraLogo} alt="Kemira" />
					<S.HeaderText>
						Acesso exclusivo para clientes Kemira
					</S.HeaderText>
				</S.Header>

				<S.Hero style={{ backgroundImage: `url(${wallpaper})` }}>
					<S.HeroContent>
						<S.Title>Agendamento de coleta</S.Title>
						<S.Subtitle>
							Digite o número da sales order enviada para o seu
							email para realizar o agendamento.
						</S.Subtitle>

						<S.Form onSubmit={handleSubmit} noValidate>
							<S.Input
								aria-label="Número da sales order"
								placeholder="Digite o número da sales order"
								value={orderNumber}
								onChange={(event) => {
									setOrderNumber(event.target.value);
									setMessage("");
								}}
							/>
							<S.SubmitButton type="submit" disabled={loading}>
								{loading ? "Buscando..." : "Buscar sales order"}
							</S.SubmitButton>
						</S.Form>
						<S.Message role="status" aria-live="polite">
							{message}
						</S.Message>
					</S.HeroContent>
				</S.Hero>

				<S.Footer>
					<S.Copyright>
						Powered by GS Tecnologia e Inovação®
					</S.Copyright>
					<S.WebcolLogo src={webcolLogo} alt="Webcol" />
				</S.Footer>
			</S.Frame>
		</S.Page>
	);
};

export default AgendamentoFob;
